<template>
	<v-avatar 
		:color="color" 
		:size="size"
		:min-width="size"
		:min-height="size"
		:left="left"
	>
		<span :style="'color: ' + text_color" v-if="imgerror">
			{{ image_code }}
		</span>
		<img 
			:src="image"
			@error="imgerror = true"
			v-if="!imgerror"
		/>
	</v-avatar>
</template>

<script>
export default {
	props: {
		size: {
			type: String,
			default: "32"
		},
		color: {
			type: String,
			default: 'primary'
		},
		text_color: {
			type: String,
			default: 'white'
		},
		code: {
			type: String,
			default: ''
		},
		image: {
			type: String,
			default: ''
		},
		left: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		this.imgerror = (this.image == '');
	},
	data() {
		return {
			imgerror: false
		}
	},
	computed: {
		image_code: function() {
			let code_tmp = this.code.substring(0,2).toUpperCase();

			const code_arr = this.code.split(' ');
			if (code_arr.length === 1) {
				code_tmp = this.code.substring(0,2).toUpperCase();
			}
			if (code_arr.length > 1) {
				code_tmp = `${code_arr[0].substring(0,1).toUpperCase()}${code_arr[1].substring(0,1).toUpperCase()}`;
			}
			
			return code_tmp
		},
	},
	watch: {
		image: function(new_image) {
			this.imgerror = (new_image == '')
		}
	}
}
</script>